import moment from 'moment/moment';
import React from 'react'
import { useSelector } from 'react-redux';

const UserQuizLeaderBoad = () => {

  const {userDetails} = useSelector((state) => state.UserManagement);

  console.log(userDetails)

  return (
    <>
     <div class="TitleBox">
                <h4 class="Title">User Quiz Statistics</h4>
            </div> 
            <div className="Small-Wrapper">
  {/* <div className="FilterArea">
    <div className="FilterLeft">
      <div className="form-group">
        <label>Search</label>
        <input type="text" className="form-control" placeholder="Search here" />
      </div>
      <div className="form-group">
        <label>From Date</label>
        <input type="date" className="form-control" />
      </div>
      <div className="form-group">
        <label>To Date</label>
        <input type="date" className="form-control" />
      </div>
      <div className="form-group">
        <label>&nbsp;</label>
        <button className="Button">Apply</button>
        <button className="Button Cancel">
          <i className="fa fa-refresh" />
        </button>
      </div>
    </div>
    <div className="FilterRight">
      <div className="form-group">
        <label>Timeframe</label>
        <select className="form-control">
          <option>Select Timeframe</option>
          <option>Today</option>
          <option>This Week</option>
          <option>This Month</option>
          <option>This Year</option>
        </select>
      </div>
    </div>
  </div> */}
  <div className="TableList">
    <table>
      <thead>
        <tr>
          <th>S.No.</th>
          <th>Quiz ID</th>
          <th>Quiz Name</th>
          <th>Quiz Category</th>
          <th>Score(%)</th>
          <th>Total Attempts Question</th>
          <th>Skipped Question</th>
          <th>Submission Time</th>
          <th>Correct Answers</th>
          <th>Incorrect Answers</th>
          <th>Attempted At</th>
        </tr>
      </thead>
      <tbody>
{userDetails && userDetails?.quizAttempts?.map((item,index)=>{
  return(
        <tr>
          <td>{index+1}</td>
          <td>{item?.quizId}</td>
          <td>{item?.quizName}</td>
          <td>{item?.quizCategory}</td>
          <td>{item?.score}</td>
          <td>{item?.totalAttemptsQuestion}</td>
          <td>{item?.skippedQuestion}</td>
          <td>{item?.submissionTime}</td>
          <td>{item?.correctAnswers}</td>
          <td>{item?.incorrectAnswers}</td>
          <td> {item?.attemptedAt
    ? moment(item.attemptedAt).format("DD MMM YYYY, hh:mm A")
    : "-"}</td>
        </tr>
        )})  
      }
      </tbody>
    </table>
  </div>
</div>

    </>
  )
}

export default UserQuizLeaderBoad
